import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AppError } from '../../shared/services/state.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {
  handleError(error: unknown): AppError {
    if (error instanceof HttpErrorResponse) {
      // console.log("log from error handler", error);


      return {
        ...error,
        message: error?.message.indexOf("clf") > -1 ? "Error loading Topic Classifications" : 'An HTTP error occurred',
        status: error.status,
        statusText: error.statusText
      };
    }

    if (error instanceof Error) {
      return {
        ...error,
        message: error.message
      };
    }

    return {
      name: 'UnknownError',
      message: 'An unknown error occurred',
      stack: undefined
    } as AppError;
  }
}
